import { render, staticRenderFns } from "./JointItem.vue?vue&type=template&id=44ccc71c&scoped=true&"
import script from "./JointItem.vue?vue&type=script&lang=js&"
export * from "./JointItem.vue?vue&type=script&lang=js&"
import style0 from "./JointItem.vue?vue&type=style&index=0&id=44ccc71c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ccc71c",
  null
  
)

export default component.exports